<div tabindex="-1"
    (mouseenter)="setShouldBlur(false)"
    (mouseleave)="setShouldBlur(true)">
    <div>
        <section class="dropdown-section"
                 *ngFor="let category of CATEGORY_ORDER">
            <ng-container *ngIf="results && results[category] && results[category]!.length > 0">
                <div class="dropdown-header">
                    {{ CATEGORY_LABELS[category] }}
                    <a
                        class="btn btn-transparent arrow-right"
                        href="javascript:void(0)"
                        *ngIf="showMoreResultsUrl"
                        (click)="navigateToMoreResultsUrl(category)"
                    ></a>
                </div>
                <div class="dropdown-section-body">
                    <div class="dropdown-item"
                         *ngFor="let result of results[category]"
                         [ngClass]="{'active': (flatResults | indexOf:result) === selectedIndex}"
                         (click)="clickResult()"
                         (mouseenter)="setSelectedIndexOnMouseEnter(result)">
                        <dt *ngIf="result.display_security_id" class="dropdown-item-term" [textContent]="result.display_security_id"></dt>
                        <dd class="dropdown-item-text">{{ result.name }}
                            <div class="dropdown-item-descr" *ngIf="result.desc" [textContent]="result.desc"></div>
                        </dd>
                    </div>
                </div>
            </ng-container>
        </section>
        @if (globalSearch) {
            <ycn-extra-links [autocompleterId]="autocompleterId"></ycn-extra-links>
        }
    </div>
</div>
